import { render, staticRenderFns } from "./PlayPause.vue?vue&type=template&id=c85a5cba&scoped=true&"
import script from "./PlayPause.vue?vue&type=script&lang=js&"
export * from "./PlayPause.vue?vue&type=script&lang=js&"
import style0 from "./PlayPause.vue?vue&type=style&index=0&id=c85a5cba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85a5cba",
  null
  
)

export default component.exports